import { Modal, TextField } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close";
import { useContext, useState } from "react";
import { AuthContext } from "../../AuthContext/AuthContext";
import { loader } from "../../Func_genericas/loader";
import { mensagem_tem_a_certeza_de_apagar_alteracoes, operacao_erro, operacao_sucesso } from "../../Func_genericas/valores_estaticos";
import { CustomTextField } from "../../Styles/theme/customThemeprovider";
import { del, post, put } from "../../Services/tokenConfig";
import { func_print } from "../../Func_genericas/func_print";
import ConfirmDialog from "../../Components/CustomDialog/customdialog";
import { IManutencaoFormData, IMaquina } from "../../Interfaces/equipamentos/equipamentos";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

interface I_aux {
    list: IManutencaoFormData[],
    flag_open_modal: boolean,
    set_flag_open_modal: React.Dispatch<React.SetStateAction<boolean>>,
    flag_open_modal_ver_mais: boolean,
    set_flag_open_modal_ver_mais: React.Dispatch<React.SetStateAction<boolean>>,
    flag_open_modal_edit: boolean,
    set_flag_open_modal_edit: React.Dispatch<React.SetStateAction<boolean>>,
    flag_open_modal_add: boolean,
    set_flag_open_modal_add: React.Dispatch<React.SetStateAction<boolean>>,
    setMessage: React.Dispatch<React.SetStateAction<string>>,
    setOpenSnackSuccess: React.Dispatch<React.SetStateAction<boolean>>,
    setOpenSnackError: React.Dispatch<React.SetStateAction<boolean>>,
    set_list: React.Dispatch<React.SetStateAction<IManutencaoFormData[]>>,
    set_obj_new: React.Dispatch<React.SetStateAction<IManutencaoFormData | undefined>>,
    obj_new: IManutencaoFormData | undefined,
    obj_equipamento: IMaquina | undefined,

}

export const Modaladdmanutencao: React.FC<I_aux> = ({
    list,
    flag_open_modal,
    set_flag_open_modal,
    flag_open_modal_ver_mais,
    set_flag_open_modal_ver_mais,
    flag_open_modal_edit,
    set_flag_open_modal_edit,
    flag_open_modal_add,
    set_flag_open_modal_add,
    setMessage,
    setOpenSnackSuccess,
    setOpenSnackError,
    set_list,
    set_obj_new,
    obj_new,
    obj_equipamento,
}) => {
    const auth = useContext(AuthContext);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [campo_obrigatorio_nome, set_campo_obrigatorio_nome] = useState<boolean>(false);

    const [flag_editado, set_flag_editado] = useState<boolean>(false);
    const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = useState<boolean>(false);
    const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes_manutencao, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes_manutencao] = useState<boolean>(false);


    const [error_custo, set_error_custo] = useState<boolean>(false);
    const [error_quilometros_horas, set_error_quilometros_horas] = useState<boolean>(false);

    const handler_add_manutencao = async () => {

        if (obj_new?.descricao === undefined || obj_new?.descricao === '') {
            set_campo_obrigatorio_nome(true)

        } else {

            try {
                setIsLoading(true);
                let res = await post(auth.token.cookie_token, 'api/maquinas/' + obj_equipamento?.id_maquina + '/manutencao/new', {
                    payload: {
                        descricao: obj_new?.descricao === undefined ? '' : obj_new?.descricao,
                        tipo_manutencao: obj_new?.tipo_manutencao === undefined ? '' : obj_new?.tipo_manutencao,
                        data: obj_new?.data === undefined ? null : obj_new?.data,
                        oficina: obj_new?.oficina === undefined ? '' : obj_new?.oficina,
                        custo: obj_new?.custo === undefined ? 0 : obj_new?.custo?.toString().replace(',', '.'),
                        quilometros_horas: obj_new?.quilometros_horas === undefined ? 0 : obj_new?.quilometros_horas?.toString().replace(',', '.'),
                        documento_ref: obj_new?.documento_ref === undefined ? null : obj_new?.documento_ref,

                    }
                });
                if (list === undefined || list.length === 0) {
                    set_list([res.data.result])

                } else {
                    set_list((old: any) => [...old, res.data.result])

                }
                setMessage(operacao_sucesso)
                setOpenSnackSuccess(true);
                setIsLoading(false);
                func_reset_all()

            } catch (error) {
                func_print("handler_add_manutencao", error, true);
                setMessage(operacao_erro)
                setOpenSnackError(true);
                setIsLoading(false);
            }
        }

    }
    const handler_edit_manutencao = async () => {

        if (obj_new?.descricao === undefined || obj_new?.descricao === '') {
            set_campo_obrigatorio_nome(true)

        } else {

            try {
                setIsLoading(true);
                let res = await put(auth.token.cookie_token, 'api/maquinas/manutencao/' + obj_new?.id_manutencao, {
                    payload: {
                        id_manutencao: obj_new?.id_manutencao === undefined ? 0 : obj_new?.id_manutencao,
                        descricao: obj_new?.descricao === undefined ? '' : obj_new?.descricao,
                        tipo_manutencao: obj_new?.tipo_manutencao === undefined ? '' : obj_new?.tipo_manutencao,
                        data: obj_new?.data === undefined ? null : obj_new?.data,
                        oficina: obj_new?.oficina === undefined ? '' : obj_new?.oficina,
                        custo: obj_new?.custo === undefined || obj_new?.custo === null ? 0 : obj_new?.custo.toString().replace(',', '.'),
                        quilometros_horas: obj_new?.quilometros_horas === undefined || obj_new?.quilometros_horas === null ? 0 : obj_new?.quilometros_horas.toString().replace(',', '.'),
                        documento_ref: obj_new?.documento_ref === undefined ? null : obj_new?.documento_ref,

                    }
                });

                let aux_list = list.map((el) => {
                    if (el.id_manutencao === obj_new.id_manutencao) {
                        return res.data.result
                    } else {
                        return el
                    }
                })

                set_list(aux_list)


                setMessage(operacao_sucesso)
                setOpenSnackSuccess(true);
                setIsLoading(false);
                func_reset_all()

            } catch (error) {
                func_print("handler_edit_manutencao", error, true);
                setMessage(operacao_erro)
                setOpenSnackError(true);
                setIsLoading(false);
            }
        }

    }

    const onInputChange = (e: any) => {
        const { name, value } = e.target;
        set_flag_editado(true)
        if (name === 'custo') {
            if (!/^(\d+([.,]\d+)?)$/.test(value)) {
                set_error_custo(true)
            } else {
                set_error_custo(false)
            }
        }
        if (name === 'quilometros_horas') {
            if (!/^(\d+([.,]\d+)?)$/.test(value)) {
                set_error_quilometros_horas(true)
            } else {
                set_error_quilometros_horas(false)
            }
        }
        set_obj_new((prev: any) => ({
            ...prev,
            [name]: value,
        }));
    }


    const func_reset_all = () => {
        set_obj_new(undefined);
        set_flag_open_modal_edit(false);
        set_flag_open_modal(false);
        set_campo_obrigatorio_nome(false);
        set_flag_open_modal(false);
        set_flag_editado(false)
        set_flag_open_modal_ver_mais(false);
        set_flag_open_modal_add(false);
        set_error_quilometros_horas(false)
        set_error_custo(false)


    }
    const handleCloseDialog = () => {
        func_reset_all()
        set_flag_editado(false)
        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
    };
    const func_reset_all_manutencao = () => {
        set_flag_open_modal(false);
        set_flag_open_modal_ver_mais(false);
        set_flag_open_modal_edit(false);
        set_flag_open_modal_add(false);
        set_obj_new(undefined);

    }
    const handle_delete_manutencao = async () => {
        try {
            setIsLoading(true);
            await del(auth.token.cookie_token, `/api/maquinas/manutencao/${obj_new?.id_manutencao}`);
            list.splice(list.findIndex((manutencao) => manutencao.id_manutencao === obj_new?.id_manutencao), 1);

            func_reset_all_manutencao()
            set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes_manutencao(false)
            setMessage(operacao_sucesso);
            setOpenSnackSuccess(true);
            setIsLoading(false);
        } catch (error) {
            func_print("handle_delete_manutencao", error, true);
            setIsLoading(false);
            if ((error as any)?.response?.data?.message) {
                setMessage((error as any).response.data.message);
            } else {
                setMessage(operacao_erro);
            }
            setOpenSnackError(true);
        }
    };
    return (<Modal
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
        open={flag_open_modal}
    >
        <div className="flex flex-col bg-white w-[70%] max-h-[80%] rounded-xl overflow-hidden">
            <div className="flex items-center justify-between w-full p-1 border-b border-gray-100">
                <div></div>

                <button
                    type="button"
                    onClick={() => {
                        if (flag_editado) {
                            set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                        } else {
                            set_flag_open_modal(false)
                            set_flag_open_modal_edit(false)
                            set_flag_open_modal_ver_mais(false)
                        }
                    }}
                    className="p-1 text-gray-400 hover:text-gray-600 transition-colors border-0 outline-none cursor-pointer !bg-transparent hover:!bg-transparent"
                >
                    <CloseIcon sx={{ fontSize: 24 }} />
                </button>
            </div>

            {
                isLoading === true ?
                    loader() :
                    <>

                        <div className="flex flex-col items-center w-full flex-1 overflow-auto">


                            <div className="flex items-center justify-between mt-4 pl-5 w-full mb-4 pr-4">
                                <div className="grid grid-cols gap-2 ">

                                    <h2 className="text-xl font-semibold text-gray-800 m-0 pl-2">
                                        {
                                            flag_open_modal_edit === true ? 'Editar Manutenção' :
                                                flag_open_modal_ver_mais === true ? 'Detalhes do Manutenção' :
                                                    'Adicionar Manutenção'
                                        }
                                    </h2>


                                </div>

                                {
                                    flag_open_modal_add === false && flag_open_modal_edit === false ?
                                        <div className="flex justify-between gap-2">
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    set_flag_open_modal_ver_mais(false);
                                                    set_flag_open_modal_edit(true);
                                                    set_flag_open_modal_add(false);

                                                }}
                                                className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                            >
                                                <EditIcon sx={{ fontSize: 18 }} />
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes_manutencao(true)

                                                }}
                                                className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                            >
                                                <DeleteIcon sx={{ fontSize: 18 }} />
                                            </button>
                                        </div>
                                        : <></>
                                }
                            </div>

                            <div className="flex flex-col gap-6 w-full p-5 rounded-xl bg-gray-50/80">
                                <div className="flex flex-wrap gap-6 w-full">
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Descrição</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new?.descricao || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Descrição'
                                                            name="descricao"
                                                            error={campo_obrigatorio_nome}
                                                            helperText={campo_obrigatorio_nome ? 'Campo obrigatório' : ''}
                                                            value={obj_new?.descricao === undefined ? '' : obj_new?.descricao}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>
                                        }
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Tipo de Manutenção</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new?.tipo_manutencao || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Tipo de Manutenção'
                                                            name="tipo_manutencao"
                                                            value={obj_new?.tipo_manutencao === undefined ? '' : obj_new?.tipo_manutencao}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>
                                        }
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>

                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Data</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new?.data || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <TextField
                                                            variant="outlined"
                                                            label='Data'
                                                            name="data"
                                                            type="date"
                                                            value={obj_new?.data === undefined ? '' : obj_new?.data}
                                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                                set_flag_editado(true)

                                                                set_obj_new((old: any) => ({
                                                                    ...old,
                                                                    'data': event.target.value,
                                                                }));

                                                            }}
                                                            fullWidth
                                                            margin="normal"
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />

                                                    </div> : <></>
                                        }
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Custo</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new?.custo ?? '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Custo'
                                                            name="custo"
                                                            error={error_custo}
                                                            helperText={error_custo ? 'Insira apenas números' : ''}
                                                            value={obj_new?.custo === undefined ? '' : obj_new?.custo}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>}
                                    </div>
                                </div>
                                <div className="flex flex-wrap gap-6 w-full">
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Quilometros/Horas</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new?.quilometros_horas || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Quilometros/Horas'
                                                            name="quilometros_horas"
                                                            error={error_quilometros_horas}
                                                            helperText={error_quilometros_horas ? 'Insira apenas números' : ''}
                                                            value={obj_new?.quilometros_horas === undefined ? '' : obj_new?.quilometros_horas}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />

                                                    </div> : <></>}
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Oficina</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new?.oficina || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Oficina'
                                                            name="oficina"
                                                            value={obj_new?.oficina === undefined ? '' : obj_new?.oficina}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>}
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Documento de Referência</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new?.documento_ref || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Documento de Referência'
                                                            name="documento_ref"
                                                            value={obj_new?.documento_ref === undefined ? '' : obj_new?.documento_ref}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div>

                                                    : <></>}
                                    </div>

                                </div>
                                {/* row 2: switches */}
                                {flag_open_modal_ver_mais === true ? <></> :

                                    <div className="flex justify-end w-full pt-4">
                                        <button
                                            type="button"
                                            onClick={() => {


                                                if (obj_new?.descricao === undefined || obj_new.descricao === '') {
                                                    set_campo_obrigatorio_nome(true);
                                                } else {

                                                    set_campo_obrigatorio_nome(false);
                                                    if (flag_open_modal_edit === true && flag_open_modal_add === false) {
                                                        handler_edit_manutencao()
                                                    } else if (flag_open_modal_add === true) {
                                                        handler_add_manutencao()
                                                    }
                                                }
                                            }}
                                            className="px-5 py-2.5 mt-4 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                        >
                                            Guardar Informação
                                        </button>
                                    </div>
                                }
                            </div>




                        </div>
                    </>
            }
            <ConfirmDialog
                open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
                onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
                onConfirm={() => handleCloseDialog()}
                message={mensagem_tem_a_certeza_de_apagar_alteracoes}
            />
            <ConfirmDialog
                open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes_manutencao}
                onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes_manutencao(false)}
                onConfirm={() => handle_delete_manutencao()}
                message={'Deseja eliminar o registo?'}
            />
        </div>



    </Modal>)

}
